export class Background {
    constructor(scene) {
        this.scene = scene;
        this.addGradientBackground();
        this.addBackgroundCircles();
    }
    addBackgroundCircles() {
        this.backgroundCircles = this.scene.add.image(0, 0, 'bg_circles').setScale(0);
    }
    addPlainBackground() {
        this.background = this.scene.add.rectangle(0, 0, 1, 1, 0x72131dd);
    }
    addGradientBackground() {
        let { width, height } = this.scene.resizeDim;
        width /= this.scene.grs.dpr;
        height /= this.scene.grs.dpr;
        let canvasTexture;
        if (this.scene.textures.exists('backgroundTex')) {
            canvasTexture = this.scene.textures.get('backgroundTex');
        }
        else {
            canvasTexture = this.scene.textures.createCanvas('backgroundTex', width, height);
        }
        if (!canvasTexture) {
            this.addPlainBackground();
            return;
        }
        const context = canvasTexture.getContext();
        const gradient = context.createRadialGradient(width * 0.5, height * 0.5, 0, width * 0.5, height * 0.5, height);
        gradient.addColorStop(0, '#000000');
        gradient.addColorStop(1, '#000000');
        context.fillStyle = gradient;
        context.fillRect(0, 0, width, height);
        // // Below is required only when running the game in WEBGL
        canvasTexture.refresh();
        this.background = this.scene.add.image(0, 0, 'backgroundTex');
        this.background.setOrigin(0.5);
    }
    resizeAndRepositionElements(w, h) {
        const width = w / this.background.width;
        const height = h / this.background.height;
        this.background.setScale(width > height ? width : height);
    }
}
